import firebase from "firebase/app";
import "firebase/functions";

const functions = firebase.functions();
if (process.env.NODE_ENV === 'development') {
//   console.log('using functions emulator');
  // functions.useEmulator("localhost", 5000);
}

const cacallable = ((func, data) => {
  const call = functions.httpsCallable(func);
  return call(data);
});

const joinCompany = ((data) => {
  const call = functions.httpsCallable("company-joinCompany");
  return call(data);
});
const sendCompanyInvite = ((data) => {
  const call = functions.httpsCallable("company-sendCompanyInvite");
  return call(data);
});
const createCompany = ((data) => {
  const call = functions.httpsCallable("company-createCompany");
  return call(data);
});

const sendJoinGroupInvite = ((data) => {
  const call = functions.httpsCallable("trip-sendJoinGroupInvite");
  return call(data);
});

const removeUserFromTrip = (data) => {
  const call = functions.httpsCallable("user-requestUserDeletion");
  return call(data);
};

const acceptUser = (data) => {
  const call = functions.httpsCallable("user-acceptUser");
  return call(data);
};

const createPaymentIntent = ((companyId, amount, saveCard, pm) => {
  const call = functions.httpsCallable("customer-paymentIntent");
  return call({
    amount,
    save_card: saveCard,
    payment_method: pm,
    company: companyId,
  });
});
const createTrip = (trip, addons) => {
  const call = functions.httpsCallable("trip-createNewGroup");
  return call({ trip, addons });
};

const joinTrip = ((tripId, subgroupId) => {
  const call = functions.httpsCallable("trip-requestJoinGroup");
  return call({ tripId, subgroupId });
});
const addAdminsToTrip = ((tripId, admins) => {
  const call = functions.httpsCallable("trip-addAdminsToGroup");
  return call({ tripId, admins });
});

const flight = ((tripId, date, event, alarms, flightId) => {
  console.log("calling cloud function");

  const call = functions.httpsCallable("flight");

  return call({
    tripId,
    flight_date: date,
    flight_data: event,
    alerts: alarms,
    flight_id: flightId,
  });
});

export default {
  flight,
  joinTrip,
  createTrip,
  sendJoinGroupInvite,
  createPaymentIntent,
  call: cacallable,
  removeUserFromTrip,
  acceptUser,
  createCompany,
  sendCompanyInvite,
  joinCompany,
  addAdminsToTrip,
};
